import React, { Fragment, useContext } from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { getTimeRangeSlug } from '../../helpers/time-ranges';
import { FeatureFlagsContext, PromotionPositionContext } from '../../context';
import WhatsOnListItem from './whats-on-list-item';
import WhatsOnMoreList from './whats-on-more-list';
import styles from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_INITIAL_LOAD = 10;
const WhatsOnList = _ref => {
  let {
    ranges,
    id,
    analyticsDisplayId
  } = _ref;
  const IS_SEE_MORE = useContext(FeatureFlagsContext).NEXT_PUBLIC_TOGGLE_WHATS_HAPPENING_SEE_MORE;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.whatsOnListContainer, styles.evolved),
    id: id,
    "aria-live": "polite",
    "data-id": "whats-on-list_index_WhatsOnList_div",
    children: ranges.map(range => {
      const slug = getTimeRangeSlug(range.name);
      const showLoadMore = IS_SEE_MORE && range.items.length > MAX_INITIAL_LOAD;
      const items = showLoadMore ? range.items.slice(0, MAX_INITIAL_LOAD) : range.items;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.dividerContainer,
          "data-id": "whats-on-list_index_WhatsOnList_Fragment_div_1",
          children: [/*#__PURE__*/_jsx(Heading, {
            type: "megasmalldivider",
            className: styles.divider,
            id: "".concat(slug, "-heading"),
            "data-id": "whats-on-list_index_WhatsOnList_div_Heading",
            children: range.name
          }), items.length !== 0 && /*#__PURE__*/_jsx("div", {
            className: styles.countPill,
            "data-id": "whats-on-list_index_WhatsOnList_div",
            children: "".concat(items.length, " item").concat(items.length === 1 ? '' : 's')
          })]
        }), items.length === 0 ? /*#__PURE__*/_jsx("div", {
          className: styles.emptyGroup,
          "data-id": "whats-on-list_index_WhatsOnList_div_4",
          children: /*#__PURE__*/_jsxs(Paragraph, {
            "data-id": "whats-on-list_index_WhatsOnList_div_Paragraph",
            children: ["No content on ", range.name.toLowerCase(), " please change your search criteria"]
          })
        }) : /*#__PURE__*/_jsx("ul", {
          id: "".concat(slug, "-list"),
          className: showLoadMore ? styles.listWithLoadMore : styles.list,
          "data-id": "whats-on-list_index_WhatsOnList_ul",
          children: /*#__PURE__*/_jsxs(PromotionPositionContext.Provider, {
            value: "".concat(analyticsDisplayId, "/").concat(slug),
            children: [items.map((item, i) => /*#__PURE__*/_jsx(WhatsOnListItem, {
              item: item,
              "data-id": "whats-on-list_index_WhatsOnList_WhatsOnListItem"
            }, i)), showLoadMore && /*#__PURE__*/_jsx(WhatsOnMoreList, {
              range: range.name,
              items: range.items.slice(MAX_INITIAL_LOAD),
              "data-id": "whats-on-list_index_WhatsOnList_WhatsOnMoreList"
            })]
          })
        })]
      }, range.name);
    })
  });
};
export default WhatsOnList;